import React from 'react';
import {Droppable} from 'react-beautiful-dnd';
import {useDispatch, useSelector} from 'react-redux';

import {OPERATE_TYPES} from 'api/constants';
import {selectWisbit} from 'store/selectors';

import {createBit} from './redux/actions';
import {saveWisbit} from './redux/thunks';

import AddBitButton from './AddBitButton';
import DraggableBit from './DraggableBit';
import {FIELDS} from './constants';

type DroppableBitsProps = {
  disabled?: boolean;
};

function DroppableBits({disabled}: DroppableBitsProps) {
  const {bits} = useSelector(selectWisbit);
  const dispatch = useDispatch();

  const onCreateBit = () => {
    dispatch(createBit());

    dispatch(saveWisbit({op: OPERATE_TYPES.ADD, field: FIELDS.BITS}));
  };

  const renderAddButton = () =>
    !disabled ? <AddBitButton onCreate={onCreateBit} /> : null;

  return (
    <div className="flex flex-col">
      {bits &&
        bits.map((bit, index, _bits) => {
          if (index % 2 === 0) {
            return (
              <Droppable
                key={bit.id}
                droppableId={`bits_${bit.id}`}
                type="bit"
                direction="horizontal"
              >
                {provided => (
                  <div
                    className="flex"
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    <DraggableBit
                      index={index}
                      bitData={bit}
                      disabled={disabled}
                    />
                    {_bits[index + 1] ? (
                      <DraggableBit
                        key={_bits[index + 1].id}
                        index={index + 1}
                        bitData={_bits[index + 1]}
                        disabled={disabled}
                      />
                    ) : (
                      renderAddButton()
                    )}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            );
          }
          return null;
        })}
      {!(bits && bits.length % 2 !== 0) && renderAddButton()}
    </div>
  );
}

export default DroppableBits;
